import { CHART_LABEL_MAX_LENGTH } from '../constants/materialDashboardConstants';

/**
 * Acorta etiquetas largas de ejes de gráficos.
 * @param {string} value Texto original.
 * @param {number} [maxLength] Largo máximo.
 * @returns {string}
 */
export const truncateChartLabel = (value, maxLength = CHART_LABEL_MAX_LENGTH) => {
  const label = String(value || '-');
  return label.length > maxLength ? `${label.slice(0, maxLength - 1)}…` : label;
};
